import React from 'react';
import { Row, Col, Alert, Button } from 'react-bootstrap';

import FieldGroup from './common/FieldGroup.jsx';
import DropDownInput from './common/DropDownInput.jsx';

import OrderDetailListContainer from '../containers/OrderDetailListContainer.jsx';

export default class OrderDetailEditComponent extends React.Component {

	componentDidMount() {
		this.props.findAllGears();
	}

	render() {
		return (
			<div>
				<Row>
					<Col xs={12} sm={12} md={12}>
						<OrderDetailListContainer orderId={this.props.orderDetail.get('orderId')} />
					</Col>
				</Row>
				<Row>
					<Col xs={2} sm={2} md={2}>
						<Button onClick={this.props.editOrderDetail} bsStyle="info">
							Submit
					    </Button>
					</Col>
					<Col xs={10} sm={10} md={10}>
						<Alert bsStyle={this.props.alertStyle}>
							{this.props.alertMessage}
						</Alert>
					</Col>
				</Row>
				<br />
				<Row>
					<Col xs={12} sm={12} md={12}>
						<label className="control-label" style={{ marginBottom: 20 }}>訂單編號: {this.props.orderDetail.get('orderId')}</label>
						<FieldGroup
							id="sOrderDetailId"
							type="number"
							label="產品編號 (KEY => 如果該編號已存在則會修改資料)"
							value={this.props.orderDetail.get('sOrderDetailId')}
							disabled={!this.props.forInsert}
							placeholder=""
							required="true"
							onChange={(id, value) => {
								this.props.setValue(id, value);
							}}
							validation={this.props.orderDetailValidation.get('sOrderDetailId')}
						/>
						<DropDownInput id="gearName"
							label="產品名稱"
							required="true"
							options={this.props.allGears.map((value, key) => ({ label: value.get('alias_name'), value: value.get('gear_name') })).toJS()}
							selected={[{ label: this.props.orderDetail.get('gearAliasName'), value: this.props.orderDetail.get('gearName') }]}
							onChange={(id, value, label) => {
								this.props.setValue(id, value);
								this.props.setValue('gearAliasName', label);
								this.props.setValue('customerGearName', label);
								this.props.findGearSpecIdsByGearName({gear_name: value});
								this.props.changeShowSpecIdHasLabel({gear_name: value});
							}}
							validation={this.props.orderDetailValidation.get('gearName')}
						/>
						<FieldGroup
							id="customerGearName"
							type="text"
							label="產品名稱-客製"
							value={this.props.orderDetail.get('customerGearName')}
							placeholder=""
							required="true"
							onChange={(id, value) => {
								this.props.setValue(id, value);
							}}
							validation={this.props.orderDetailValidation.get('customerGearName')}
						/>
						<FieldGroup
							id="sQuantity"
							type="number"
							label="訂貨數量"
							value={this.props.orderDetail.get('sQuantity')}
							placeholder=""
							required="true"
							onChange={(id, value) => {
								this.props.setValue(id, value);
							}}
							validation={this.props.orderDetailValidation.get('sQuantity')}
						/>
						<div style={{display: this.props.showSpecIdHasLabel}}>
						<DropDownInput id="specIdHasLabel"
							label="料號"
							options={this.props.specIds.map((value, key) => ({ label: value, value: value })).toJS()}
							selected={[{ label: this.props.orderDetail.get('specIdHasLabel'), value: this.props.orderDetail.get('specIdHasLabel') }]}
							onChange={(id, value, label) => {
								this.props.setValue(id, value);
							}}
							validation={this.props.orderDetailValidation.get('specIdHasLabel')}
						/>
						</div>
						<div style={{display: this.props.showSpecIdNoLabel}}>
						<FieldGroup
							id="specIdNoLabel"
							type="text"
							label="料號"
							value={this.props.orderDetail.get('specIdNoLabel')}
							placeholder=""
							onChange={(id, value) => {
								this.props.setValue(id, value);
							}}
							validation={this.props.orderDetailValidation.get('specIdNoLabel')}
						/>
						</div>
						<FieldGroup
							id="modelName"
							type="text"
							label="型號"
							value={this.props.orderDetail.get('modelName')}
							placeholder=""
							onChange={(id, value) => {
								this.props.setValue(id, value);
							}}
							validation={this.props.orderDetailValidation.get('modelName')}
						/>
					</Col>
				</Row>
			</div>
		)
	}
};


// WEBPACK FOOTER //
// ./src/components/OrderDetailEditComponent.jsx